import { render, staticRenderFns } from "./CallLogListPage.vue?vue&type=template&id=0821f99f&"
import script from "./CallLogListPage.vue?vue&type=script&lang=ts&"
export * from "./CallLogListPage.vue?vue&type=script&lang=ts&"
import style0 from "./CallLogListPage.vue?vue&type=style&index=0&id=0821f99f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports